module.exports = __webpack_public_path__ + "static/media/populat0.481e0818.jpg";